import isEmpty from 'lodash/isEmpty';

export function isEmailValid(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export function validateNewsletter(email) {
    const errors = {};

    if (!isEmailValid(email)) {
        errors.email = true;
    }

    return { errors, isValid: isEmpty(errors) };
}

export function validateRequestDemoForm(values) {
    const errors = {};

    if (!isEmailValid(values.businessEmail)) {
        errors.businessEmail = true;
    }

    if (!values.firstName) {
        errors.firstName = true;
    }

    if (!values.lastName) {
        errors.lastName = true;
    }

    if (!values.companyName) {
        errors.companyName = true;
    }

    if (!values.phoneNumber) {
        errors.phoneNumber = true;
    }

    if (!values.country) {
        errors.country = true;
    }

    return { errors, isValid: isEmpty(errors) };
}

export function validatePartnersForm(values) {
    const errors = {};

    if (!isEmailValid(values.businessEmail)) {
        errors.businessEmail = true;
    }

    if (!values.firstName) {
        errors.firstName = true;
    }

    if (!values.lastName) {
        errors.lastName = true;
    }

    if (!values.companyName) {
        errors.companyName = true;
    }

    if (!values.phoneNumber) {
        errors.phoneNumber = true;
    }

    if (!values.country) {
        errors.country = true;
    }

    return { errors, isValid: isEmpty(errors) };
}
